import { DateMenuTemplate, MenuTemplate } from '@types'

interface GetDateMenuTemplateCoordinator {
  RestService: {
    get: (path: string) => Promise<DateMenuTemplate>
  }
  HandleError: any
}

export const GetDateMenuTemplate =
  ({ RestService, HandleError }: GetDateMenuTemplateCoordinator) =>
  async (id: string): Promise<DateMenuTemplate | null> => {
    try {
      const template = await RestService.get(
        `group-orders/date-menu-templates/${id}`,
      )

      return template
    } catch (error) {
      HandleError({ error })

      return null
    }
  }

export interface CreateDateMenuTemplateReq {
  createdByUserId: string
  createdByEmail: string
  hqId?: number
  isPrivate: boolean
  name: string
  templates: MenuTemplate[]
}

interface CreateDateMenuTemplateCoordinator {
  RestService: {
    post: (
      path: string,
      req: CreateDateMenuTemplateReq,
    ) => Promise<DateMenuTemplate>
  }
  HandleError: any
}

export const CreateDateMenuTemplate =
  ({ RestService, HandleError }: CreateDateMenuTemplateCoordinator) =>
  async (req: CreateDateMenuTemplateReq): Promise<DateMenuTemplate | null> => {
    try {
      const template = await RestService.post(
        `group-orders/date-menu-templates`,
        req,
      )

      return template
    } catch (error) {
      HandleError({ error })

      return null
    }
  }

export interface UpdateDateMenuTemplateReq {
  id: string
  updatedByUserId: string
  updatedByEmail: string
  hqId?: number
  isPrivate?: boolean
  name?: string
  templates?: MenuTemplate[]
}

interface UpdateDateMenuTemplateCoordinator {
  RestService: {
    put: (
      path: string,
      req: UpdateDateMenuTemplateReq,
    ) => Promise<DateMenuTemplate>
  }
  HandleError: any
}

export const UpdateDateMenuTemplate =
  ({ RestService, HandleError }: UpdateDateMenuTemplateCoordinator) =>
  async (req: UpdateDateMenuTemplateReq): Promise<DateMenuTemplate | null> => {
    try {
      const template = await RestService.put(
        `group-orders/date-menu-templates/${req.id}`,
        req,
      )

      return template
    } catch (error) {
      HandleError({ error })

      return null
    }
  }

export interface SearchDateMenuTemplatesReq {
  ids?: string[]
  nameSearch?: string
  hqId?: number
  allHqs?: boolean
  isPrivate?: boolean
  createdByUserId?: string
  offset: number
  limit: number
}

interface SearchDateMenuTemplatesCoordinator {
  RestService: {
    get: (
      path: string,
      req: SearchDateMenuTemplatesReq,
    ) => Promise<DateMenuTemplate[]>
  }
  HandleError: any
}

export const SearchDateMenuTemplates =
  ({ RestService, HandleError }: SearchDateMenuTemplatesCoordinator) =>
  async (
    req: SearchDateMenuTemplatesReq,
  ): Promise<DateMenuTemplate[] | null> => {
    try {
      const templates = await RestService.get(
        `group-orders/date-menu-templates`,
        req,
      )

      return templates
    } catch (error) {
      HandleError({ error })

      return null
    }
  }

interface DeleteDateMenuTemplatesCoordinator {
  RestService: {
    delete: (path: string) => Promise<null>
  }
  HandleError: any
}

export const DeleteDateMenuTemplates =
  ({ RestService, HandleError }: DeleteDateMenuTemplatesCoordinator) =>
  async (id: string): Promise<boolean> => {
    try {
      await RestService.delete(`group-orders/date-menu-templates/${id}`)

      return true
    } catch (error) {
      HandleError({ error })

      return false
    }
  }
